export const API_URL = `https://restcountries.com/v3.1/all`;
